import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import axios from "../axios";
import qs from "qs";
import Alert from "react-s-alert";
import FormDropdown from "./FormDropdown";

const tipe_reset = [
    { key: "soft", value: "Soft Reset" },
    { key: "hard", value: "Hard Reset" }
];


class ResetUjianModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            option: [],
            isButtonLoading: false,
            isLoading: false,
            tipe_reset_name: "",
            score: this.props.score
        };

        this.handleToggle = this.handleToggle.bind(this);
        this.handleSubmitReset = this.handleSubmitReset.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleSubmitReset() {

        this.setState({ isButtonLoading: true });
        const url = '/ujian/reset';
        const qOption = JSON.stringify(this.state.option);

        let newState = {
            entry_id: this.props.entry_id,
            user_id: this.props.user_id,
            tipe_reset_name: this.state.tipe_reset_name
        };


        axios({
            method: "post",
            url: url,
            data: qs.stringify(newState)
        })

            .then(response => {
                const result = response.data;

                if (result.success) {
                    window.location.reload();
                    Alert.success(result.message);
                } else {
                    if (Array.isArray(result.message)) {
                        result.message.map(item => {
                            Alert.error(item);
                            return true;
                        });
                    } else {
                        Alert.error(result.message);
                    }

                    this.setState({ isButtonLoading: false });
                }
            })

            .catch(error => {
                console.log(error);
                this.setState({ isButtonLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleToggle() {
        this.props.toggleModalEdit()
    }

    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.handleToggle} className="modal-primary">
                <ModalHeader toggle={this.handleToggle}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>
                    {/*Form*/}
                    <div className="card">
                        <div className="card-header">Pilih Reset</div>
                        <div className="card-block">
                            <div className="form-group row">
                                <div className="col-md-12">
                                    <FormDropdown
                                        items = {tipe_reset}
                                        onChange = {this.handleChange}
                                        value={this.state.tipe_reset_name.toString()}
                                        placeholder={"Pilih Type"}
                                        name="tipe_reset_name"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="card-block">
                            <p><strong>*SOFT RESET</strong> berarti siswa masih bisa meneruskan pengerjaan ujian sesuai ujian, mohon perhatikan DURASI UJIAN</p>
                            <p><strong>*HARD RESET</strong> berarti seluruh pegerjaan siswa ini akan hilang dan siswa melakukan pengerjaan dari awal, mohon perhatikan DURASI UJIAN</p>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" disabled={this.state.isButtonLoading && "disabled"}  onClick={this.handleSubmitReset}>{this.state.isButtonLoading ? "Loading" : "Simpan"}</Button>{' '}
                    <Button color="secondary" onClick={this.handleToggle}>Batal</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

ResetUjianModal.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalBodyText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    toggleModalEdit: PropTypes.func.isRequired,
    user_id: PropTypes.number.isRequired,
    entry_id: PropTypes.number.isRequired
}

export default ResetUjianModal


// WEBPACK FOOTER //
// ./src/components/ResetUjianModal.js